module.exports = __webpack_public_path__ + "img/payments-ico.97096b36.svg";